import React, { useId } from 'react';

export const MinesDiamond = () => {
  const id = useId().replace(/:/g, '');
  return <svg className="mines-diamond" viewBox="0 0 100 100" aria-hidden="true">
    <defs><linearGradient id={id} x1="0" y1="0" x2="1" y2="1"><stop stopColor="#a3ffce" /><stop offset="1" stopColor="#0fc67c" /></linearGradient></defs>
    <path d="m8 35 20-21h44l20 21-42 53Z" fill={`url(#${id})`} stroke="#bbffe1" strokeWidth="2" />
    <path d="m8 35 42 53-19-53ZM92 35 50 88l19-53Z" fill="#12a568" />
    <path d="m28 14 3 21 19-21 19 21 3-21Z" fill="#ddffef" />
    <path d="M31 35h38L50 88Z" fill="#4ef5a4" /><path d="m28 14 22 0-19 21H8Z" fill="#79ffc4" />
    <path d="m50 14 19 21H31Z" fill="#caffdf" />
  </svg>;
};

export const MinesBomb = () => {
  const id = useId().replace(/:/g, '');
  return <svg className="mines-bomb" viewBox="0 0 100 100" aria-hidden="true">
    <defs><radialGradient id={id} cx=".3" cy=".25" r=".8"><stop stopColor="#586371" /><stop offset=".4" stopColor="#25313f" /><stop offset="1" stopColor="#0b1018" /></radialGradient></defs>
    <path d="M58 28c1-11 18-5 17-17" stroke="#ffd79b" strokeWidth="5" fill="none" strokeLinecap="round" />
    <path d="m75 2 4 7 8 1-6 6 1 8-7-4-7 4 1-8-6-6 8-1Z" fill="#ffbe43" />
    <path d="m49 23 16 5-5 15-16-5Z" fill="#131d29" stroke="#718090" strokeWidth="2" />
    <circle cx="48" cy="60" r="31" fill={`url(#${id})`} stroke="#f07b85" strokeOpacity=".6" strokeWidth="2" />
    <path d="M29 49c4-8 9-11 16-12" fill="none" stroke="#d1dde7" strokeOpacity=".7" strokeWidth="5" strokeLinecap="round" />
  </svg>;
};